<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Pagamentos</h3>
        </div>

        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="page-header row no-gutters py-2">
        <div class="col-6 text-center text-sm-left mb-0">            
          <h6 class="m-0">Valores do dia {{ filter.ReleaseDate | date("DD/MM/YYYY") }}</h6>
        </div>

        <div class="col-6 d-flex flex-column align-items-end">    
                <div class="input-group d-flex justify-content-end mb-2">
                <button
                  type="button"                  
                  class="btn btn-secondary btn-sm mt-3"
                  @click="RefreshAmounts"
                  :disabled="loadingAmounts"
                >
               <i class="fas fa-sync-alt" :class="{ 'loading': loadingAmounts }" style="margin-right: 2px;"></i> 
               <span v-if="!loadingAmounts">Atualizar valores</span>
               <span v-if="loadingAmounts">Buscando valores</span>
               </button>
             </div>
             <span v-if="queryDateTime !== null && !isNaN(new Date(queryDateTime))" class="text-uppercase page-subtitle">Última atualização: {{ queryDateTime | date("DD/MM/YYYY HH:mm:ss") }}</span>
        </div>
      </div>

      <!-- Cards -->
      <div class="grid">        
        <div
          v-for="(card, index) in Cards"
          class="small-card-body" :title="card.title"
        >
          <h5 :class="['small-card-label', card.style]">
            {{ card.label }}
            <span v-if="card.showIcon" class="info-icon">
              <i class="fas fa-info-circle" :title="card.title" style="margin-left: 5px; cursor: help;"></i>
            </span>                    
          </h5>
          <h5 class="small-card-value">{{ card.value }}</h5>          
        </div>        
      </div>      
      
      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
               <h6 class="m-0">Favorecidos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-1 col-1 text-medium">Id</th>
                    <th scope="col" class="border-0 text-left text-medium">Favorecido</th>
                    <th scope="col" class="border-0 text-center align-middle text-medium">Tipo De pagamento</th>
                    <th scope="col" class="border-0 text-center text-medium">Situação De transferência</th>
                    <th scope="col" class="border-0 text-center text-medium">Status Do Pagamento</th>
                    <th scope="col" class="border-0 text-medium">Valor a receber</th>
                  </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(
                      payment, index
                    ) in payments"
                    :key="index"
                    class="align-middle"
                  >
                    <td class="text-medium" :title="paymentsType" style="cursor: help;">{{ payment.Id }}</td>
                    <td class="text-left">
                      <span class="text-medium">{{ payment.Favorecido }}</span>
                      <br>
                      <span>{{ payment.Documento | identity }}</span>
                    </td>
                    <td class="text-center text-medium">{{ payment.TipoDePagamento }}</td>
                    <td class="text-medium">{{ payment.Repasse  }}</td>
                    <td class="text-medium">{{ payment.SituacaoPagamento }}</td>
                    <td>
                      <span :class="'badge badge-card ' + GetStyle(payment.Repasse)">{{ CentsToCurrency(payment.ValorReceber) }}</span>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      payments.length == 0
                    "
                  >
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <label for="DataDePagamento">Data de Pagamento</label>
          <date-field id="DataDePagamento" v-model="filter.ReleaseDate"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <label for="Identity">CPF/CNPJ</label>
          <the-mask
            id="Identity"
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
        <d-col md="12" class="form-group">
          <label for="Name">Nome</label>
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
            id="nome"
          />
        </d-col>
        <d-col md="4" class="form-group">
          <label for="ID">ID</label>
          <input
            id="ID"
            placeholder="ID"
            type="tex"
            class="form-control"
            v-model="filter.Id"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="8" class="form-group d-flex flex-column bg-transparent border-0">
            <label for="TipoDePagamento">Tipo de Pagamento</label>
            <d-select
                  id="TipoDePagamento"
                  v-model="filter.TipoDePagamento"
                >
                  <option value="Parceiros">Parceiros</option>
                  <option value="Merchant">Merchant</option>
                  <option value="TED">TED</option>
                  <option value="Contratos">Contratos</option>
                </d-select>
        </d-col>
        <d-col md="6" class="form-group d-flex flex-column bg-transparent border-0">
            <label for="StatusDoPagamento">Status do Repasse</label>
            <d-select id="StatusDoPagamento" v-model="filter.StatusDoPagamento">
              <option value="">Todos</option>
              <option value="Liberado">Liberado</option>
              <option value="Dados Bancários Ausentes">Dados Bancários Ausentes</option>
              <option value="Desabilitado">Desabilitado</option>
              <option value="Bloqueado">Bloqueado</option>
            </d-select>
        </d-col>
        <d-col md="6" class="form-group d-flex flex-column bg-transparent border-0">
            <label for="SituacaoPagamento">Situação de Pagamento</label>
            <d-select id="SituacaoPagamento" v-model="filter.SituacaoPagamento">
              <option value="">Todos</option>
              <option value="Pendente">Pendente</option>
              <option value="Agendado">Agendado</option>
              <option value="Depositado">Depositado</option>
              <option value="Devolvido">Devolvido</option>
              <option value="Rejeitado">Rejeitado</option>
              <option value="Previsto">Previsto</option>
              <option value="Folha">Folha</option>
              <option value="-">Sem Situação De pagamento</option>
            </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "payments",
  components: { dateField },
  data: function () {
    return {
      countFilter: 1,
      ReleaseDataAux: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      filter: {
        Identity: null,
        Id: null,
        Name: null,
        ReleaseDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        TipoDePagamento: "Merchant",
        StatusDoPagamento: "",
        SituacaoPagamento: ""
      },      
      payments: [],
      paymentsType: '',
      labelIdentity: "CPF/CNPJ",
      labelName: "Favorecido",
      loadingList: false,
      loadingReport: false,
      loadingAmounts: false,
      queryDateTime: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      valuesToPay: {
        Parceiros: { 
            Previstos: 0.0,
            Bloqueados: 0.0,
            Desabilitados: 0.0,
            DadosBancariosInvalidos: 0.0,
            Reagendamentos: 0.0,
            Complementares: 0.0,
            EnviadosBanco: 0.0
        },        
        Merchant: {
            Previstos: 0.0,
            Bloqueados: 0.0,
            Desabilitados: 0.0,
            DadosBancariosInvalidos: 0.0,
            Reagendamentos: 0.0,
            Complementares: 0.0,
            EnviadosBanco: 0.0
        },
        Contratos: {           
            EnviadosBanco: 0.0
        },
        TED: 0.0
      }
    };
  },
  computed: {
    Cards() {
      return [
        {
          label: "TED",
          value: this.CentsToCurrency(
            this.valuesToPay.TED
          ),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Comissões",
          value: this.CentsToCurrency(
            this.valuesToPay.Parceiros.EnviadosBanco
          ),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Merchants",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.EnviadosBanco),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Contratos",
          value: this.CentsToCurrency(this.valuesToPay.Contratos.EnviadosBanco),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Total a Banco",
          value: this.CentsToCurrency(
              (this.valuesToPay.Contratos.EnviadosBanco +
              this.valuesToPay.Merchant.EnviadosBanco  +
              this.valuesToPay.Parceiros.EnviadosBanco +
              this.valuesToPay.TED) || 0
          ),
          style: "payment-success",
          showIcon: false,
        },
        {
          label: "Repasses Bloqueados",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.Bloqueados),
          style: "payment-deny",
          showIcon: false,
        },
        {
          label: "Comissões Reagendados",
          value: this.CentsToCurrency(this.valuesToPay.Parceiros.Reagendamentos),
          style: "payment-absent",
          showIcon: false,
        },
        {
          label: "Merchants Reagendados",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.Reagendamentos),
          style: "payment-absent",
          showIcon: false,
        },
        {
          label: "Complementares",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.Complementares),
          style: "payment-info",
          showIcon: true,
          title: "Os valores complementares são estimativas e podem variar."
        },
        {
          label: "Previsão do Dia",
          value: this.CentsToCurrency(this.valuesToPay.Merchant.Previstos),
          style: "payment-info",
          showIcon: true,
          title: "Os valores previstos são estimativas e podem variar."
        }
      ];
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.GetPaymentList()
    },
    "pagination.RowsPerPage": function () {
      this.GetPaymentList()
    },
  },
  mounted() {
    this.RefreshAmounts();
    this.GetPaymentList();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    CentsToCurrency(value){
      if (value == NaN || value == null || value === null || value === undefined) 
          value = 0;

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value / 100);
    },
    FormatCurrency(value) {
      return this.$options.filters.currency(value)
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");      
      this.GetPaymentList()
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let params = {
          ...this.pagination,
          ...this.filter
      };
      this.$store
        .dispatch("PaymentListReport", { params: params })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    
    MergeWithDefaults: function (response, defaults) {
        let merged = Object.assign({}, defaults, response);

        for (let key in defaults) {
           if (merged[key] === null) {
               merged[key] = defaults[key];
            }
        }  
      return merged;
    },

    RefreshAmounts: function () {
      this.loadingAmounts = true;
      this.queryDateTime = null;
      let data = { "ReleaseDate": this.filter.ReleaseDate };
      this.ResetConsolidated();
      this.$store.dispatch("GetConsolidated", { params: data })
        .then((response) => {                
          this.valuesToPay = this.MergeWithDefaults(response,this.valuesToPay);
          this.queryDateTime = response.DataHoraConsulta;          
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os favorecidos",
            error
          );
        }).finally(() => { this.loadingAmounts = false; });
    },
    GetPaymentList: function () {
     this.countFilter = 0;
     if (hasValue(this.filter.Name))
     this.countFilter++;
     if (hasValue(this.filter.Identity))
     this.countFilter++;
     if (hasValue(this.filter.ReleaseDate))
     this.countFilter++;
     if (hasValue(this.filter.StatusDoPagamento))
     this.countFilter++;
     if (hasValue(this.filter.SituacaoPagamento))
     this.countFilter++;
     if (hasValue(this.filter.TipoDePagamento))
     this.countFilter++;
     if (hasValue(this.filter.Id))
     this.countFilter++;

     this.loadingList = true;
     let data = {
       ...this.pagination,
       ...this.filter
     };
     
     data.PageNumber -= 1;
     
     if(this.ReleaseDataAux != this.filter.ReleaseDate){
        console.log(this.ReleaseDataAux);
        console.log(this.filter.ReleaseDate);

        this.RefreshAmounts();
        this.ReleaseDataAux = this.filter.ReleaseDate;
     }

     this.payments = [];

     this.$store.dispatch("GetPaymentList", { params: data })  
                .then((response) => {    

                const { Dados } = Object.assign(this.valuesToPay, response) || {};
                const { Merchant, Comissao, Contratos } = Dados || {};
                const { TipoDePagamento } = this.filter || {};
                            
                const processPayments = (entity, paymentType) => {
                  if (entity && TipoDePagamento === paymentType) {
                    const dados = [
                      'EnviadosBanco', 'Previstos', 'Bloqueados', 'Reagendamentos', 
                      'Complementares', 'Desabilitados'
                    ]
                      .map(key => entity[key])
                      .find(item => item); 
                  
                    if (dados && dados.Pagamentos.length > 0) {
                      this.payments = dados.Pagamentos;
                    }
                    const { QuantidadeTotalRegistros } = dados || 0
                    if (QuantidadeTotalRegistros) {
                      this.pagination.TotalItems = QuantidadeTotalRegistros;
                    }
                    console.log(this.pagination.TotalItems);

                    this.paymentsType = paymentType;
                  }
                };

    processPayments(Merchant, 'Merchant');
    processPayments(Comissao, 'Parceiros');
    processPayments(Contratos, 'Contratos');

  })
  .catch((error) => {
    this.$makeToast(
      undefined,
      "danger",
      "Erro ao listar os favorecidos",
      error
    );
  })
  .finally(() => {
    this.loadingList = false;
    this.loadingAmounts = false;
  });

    },
    ResetFilter: function () {
      this.countFilter = 2;
      this.filter = {
        Identity: null,
        Id: null,
        Name: null,
        ReleaseDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        TipoDePagamento: "Merchant",
        StatusDoPagamento: "",
        SituacaoPagamento: ""
      };

      this.RefreshAmounts();
      this.GetPaymentList();
    },
    ResetConsolidated: function() {
      this.valuesToPay = {
        Parceiros: {
            Reagendamentos: 0.0,                  
            Previstos: 0.0,
            Bloqueados: 0.0,
            Desabilitados: 0.0,
            DadosBancariosInvalidos: 0.0,
            Reagendamentos: 0.0,
            Complementares: 0.0,
            EnviadosBanco:0.0
        },
        Merchant: {
            Reagendamentos: 0.0,                  
            Previstos: 0.0,
            Bloqueados: 0.0,
            Desabilitados: 0.0,
            DadosBancariosInvalidos: 0.0,
            Reagendamentos: 0.0,
            Complementares: 0.0,
            EnviadosBanco: 0.0
        },
        Contratos: {           
            EnviadosBanco: 0
        },
        TED: 0
      }
    },
    GetStyle: function(situacaoRepasse) {
      let styleParaSituacao = {
        "Liberado": "payment-success",
        "Bloqueado": "payment-deny",
        "Dados Bancários Ausentes": "payment-absent",
        "Desabilitado": "payment-alert"
      }

      return styleParaSituacao[situacaoRepasse] || "payment-success";
    }   
  },
};
</script>

<style>
  .grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    grid-row-gap: 20px;
    margin-bottom: 2rem;
  }
  .text-medium {
    font-size: 15px
  }
  .badge-card {
    height: 35px;
    line-height: 25px;
    font-size: 10px;
    font-weight: 800;
    min-width: 120px
  }
  .small-card-body {
  background-color: #fff;
  width: 100%;
  height: 85px;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);
}
.small-card-value {
  text-align: center;
  font-size: 18px;
  color: #192c5b
}
.small-card-label {
  font-weight: 700;
  font-size: 16px;
  color: white;
  text-align: center;
  line-height: 35px;
  width: 100%;
  height: 35px;
  border-radius: 8px 8px 0 0;
}
.payment-success {
  background-color: #4caf50;
}
.payment-deny {
  background-color: #f44336;
}
.payment-absent {
  background-color:#616161
}
.payment-alert {
  background-color:#ff9800
}
.payment-info {
  background-color: #004a79;
  border-color: #00304d;
}
.cards-time {
  align-self: flex-end; 
  font-size: 12px;
  color: #666;
}

.loading {
  animation: spin 1s linear infinite;    
}
  

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/payments.vue